import { RailTrackResponse } from '@yard/app/api'
import { action, computed, makeObservable } from 'mobx'
import { RailTrackStore } from '../../../../stores/rail-track.store'
import {
  mapRailTrackFormDataToCreateCommand,
  mapRailTrackFormDataToUpdateCommand,
} from '../../helpers/rail-track.mapper'
import { YardNodeViewStore } from './yard-node.view-store'

export interface IRailTrackFormData {
  name: string
  length?: number
}

export class RailTrackViewStore extends YardNodeViewStore<IRailTrackFormData, RailTrackStore> {
  constructor(railTrackStore: RailTrackStore) {
    super(railTrackStore)
    makeObservable(this, {
      setPosition: action,
      focusedRailTrack: computed,
    })
  }

  setPosition = (id: string, position: { x: number; y: number }) => {
    const railTrack = this.entityStore.items.find(t => t.id === id)
    if (
      railTrack &&
      (railTrack.layoutPosition.x !== position.x || railTrack.layoutPosition.y !== position.y)
    ) {
      this.entityStore.updateRailTrack({
        ...railTrack,
        layoutPosition: {
          ...railTrack.layoutPosition,
          x: Math.round(position.x),
          y: Math.round(position.y),
        },
      })
    }
  }

  setRotation = (id: string, rotation: number) => {
    const railTrack = this.entityStore.railTracks[id]

    if (railTrack && railTrack.layoutPosition.rotation !== rotation) {
      const layoutPosition = {
        ...railTrack.layoutPosition,
        rotation: Math.round(rotation),
      }

      this.entityStore.updateRailTrack({
        ...railTrack,
        layoutPosition,
      })
    }
  }

  get focusedRailTrack(): RailTrackResponse | undefined {
    return this.editingId ? this.entityStore.railTracks[this.editingId] : undefined
  }

  async submit(formData: IRailTrackFormData): Promise<void> {
    if (this.editingId) {
      const updateCommand = mapRailTrackFormDataToUpdateCommand(formData, this.focusedRailTrack!)
      await this.entityStore.updateRailTrack(updateCommand)
    } else {
      const createCommand = mapRailTrackFormDataToCreateCommand(formData, this.viewportCenter)
      await this.entityStore.addRailTrack(createCommand)
    }
  }

  async delete(id: string): Promise<void> {
    await this.entityStore.deleteRailTrack(id)
  }
}
